// src/catalog/launch/CatalogLaunchContext.jsx

import { createContext, useContext, useMemo } from "react";

const defaultLaunchContext = {
  source: "direct",
  surface: "app",
  viewId: null,
  catalogEntry: null,
  loading: false,
  error: "",
  viewDefinition: null,
  launchParams: {},
  selectedLaunchConfigurationId: null,
  backLabel: "Back to catalog",
  backTo: "/app/catalog"
};

const CatalogLaunchContext = createContext(defaultLaunchContext);

export function CatalogLaunchProvider({
  source = "direct",
  surface = "app",
  viewId = null,
  catalogEntry = null,
  loading = false,
  error = "",
  viewDefinition = null,
  launchParams = {},
  selectedLaunchConfigurationId = null,
  backLabel = "Back to catalog",
  backTo = "/app/catalog",
  children
}) {
  const value = useMemo(
    () => ({
      source,
      surface,
      viewId,
      catalogEntry,
      loading,
      error,
      viewDefinition,
      launchParams,
      selectedLaunchConfigurationId,
      backLabel,
      backTo
    }),
    [
      source,
      surface,
      viewId,
      catalogEntry,
      loading,
      error,
      viewDefinition,
      launchParams,
      selectedLaunchConfigurationId,
      backLabel,
      backTo
    ]
  );

  return (
    <CatalogLaunchContext.Provider value={value}>
      {children}
    </CatalogLaunchContext.Provider>
  );
}

export function useCatalogLaunch() {
  return useContext(CatalogLaunchContext);
}
